module.exports = __webpack_public_path__ + "static/img/system_en@2x.661dee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_us/system_en@2x.png
// module id = 436
// module chunks = 0